export default __webpack_public_path__ + "105df44f0ec63e5f23cac03cb708b081.svg";